import React, { useState } from "react";
import { fieldToInputBase } from "formik-mui";
import PropTypes from "prop-types";
import IconButton from "@mui/material/IconButton";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

export default function PasswordField({
  helperText,
  error,
  margin,
  InputProps,
  ...rest
}) {
  let [showPassword, setShowPassword] = useState(false);

  const handleMouseDownPassword = (event) => event.preventDefault();
  const iconClickHandler = () => setShowPassword(!showPassword);

  return (
    <FormControl variant="outlined" fullWidth margin={margin}>
      <InputLabel error={error} htmlFor="outlined-adornment-password">
        Password
      </InputLabel>
      <OutlinedInput
        id="outlined-adornment-password"
        type={showPassword ? "text" : "password"}
        error={error}
        {...InputProps}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={iconClickHandler}
              onMouseDown={handleMouseDownPassword}
              edge="end"
            >
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label="Password"
        // required to map to formik field using formik-mui
        {...fieldToInputBase(rest)}
      />
      <FormHelperText htmlFor="outlined-adornment-password" error={error}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}

PasswordField.propTypes = {
  inputChangeHandler: PropTypes.func,
  iconClickHandler: PropTypes.func,
  values: PropTypes.shape({
    showPassword: PropTypes.bool.isRequired,
    password: PropTypes.string.isRequired,
  }),
};
